import React from 'react';
import styled from 'styled-components';
import { Skeleton as AntdSkeleton } from 'antd';
import { SkeletonProps as AntdSkeletonProps } from 'antd/lib/skeleton';

export { default as SkeletonAvatar } from './SkeletonAvatar';
export { default as SkeletonButton } from './SkeletonButton';
export { default as SkeletonInput } from './SkeletonInput';
export { default as SkeletonImage } from './SkeletonImage';

const StyledSkeleton = styled(AntdSkeleton)`
  ul {
    margin: 0;
  }
`;

type SkeletonProps = Omit<AntdSkeletonProps, 'active'>;

const Skeleton = styled(({ ...props }: SkeletonProps) => <StyledSkeleton {...props} active />)``;

export default Skeleton;
